import type { NextApiRequest, NextApiResponse } from 'next'
import {
  type CreateUpdateOrderDTO,
  type Language,
  type NshiftUpdateSessionRequestFE,
  type NshiftUpdateSessionResponseFE
} from 'ecosystem'
import {
  createError,
  transformOrderItemsToCreateOrderItems,
  useLocaleCredentials as setLocaleCredentials
} from 'api'
import storefrontApi from 'api/storefront-api'
import { handlerWithLogging } from '../../../logging'

export const nshiftUpdateSessionHandler = handlerWithLogging(
  async (
    req: NextApiRequest,
    res: NextApiResponse<NshiftUpdateSessionResponseFE | { error: string }>
  ) => {
    const locale = (req.cookies.NEXT_LOCALE as Language) || 'sv'
    setLocaleCredentials(locale)

    if (req.method !== 'POST') {
      res.status(405).json({ error: 'Method not supported.' })
      return
    }

    const { storefrontOrderNumber, ...nshiftDetails } = req.body as NshiftUpdateSessionRequestFE

    try {
      const { data: order, error } = await storefrontApi.orders.getStorefrontOrder({
        orderNumber: storefrontOrderNumber
      })

      if (error || !order) {
        throw createError(error || 'Get nshift information error')
      }

      const newOrder: CreateUpdateOrderDTO = {
        ...order,
        customer: null,
        items: transformOrderItemsToCreateOrderItems(order.items ?? []),
        shippingInfo: {
          ...order.shippingInfo,
          additionalInfo: {
            ...order.shippingInfo?.additionalInfo,
            nshiftDetails: {
              ...order.shippingInfo?.additionalInfo?.nshiftDetails,
              ...nshiftDetails
            }
          }
        }
      }

      await storefrontApi.orders.updateStorefrontOrder(newOrder)

      res.status(200).json({ success: true } as NshiftUpdateSessionResponseFE)
    } catch (e) {
      const responseError = e instanceof Error ? e.message : 'unknown'

      res.status(400).json({ error: responseError })
    }
  }
)
